import styled from 'styled-components';
import { getColor } from '@karma/components/colors';

export const StyledTermsPrivacy = styled.section`
  margin-top: 90px;
  margin-bottom: 60px;
  font-weight: 400;
  color: ${getColor('primary1')};
`;
